import React from 'react';

const RatingTopFlopButton = (props) => {
  const { value, setValue, label, style = {} } = props;
  const border = style.border || '0.5px solid rgba(115, 115, 115, 0.2)';
  const borderRadius = style.borderRadius || 6;
  const height = style.height || 56;
  const fontSize = style.fontSize || 16;

  const color = value === 1 ? 'rgba(17, 174, 42, 0.4)' : value === 0 ? 'rgba(176, 0, 0, 0.8)' : 'rgba(115, 115, 115, 0.1)';
  const buttonSize = height - 14;
  const buttonStyle = {
    float: 'left',
    border: value === 0 ? '1px solid rgba(176, 0, 0, 0.8)' : '1px solid rgba(115, 115, 115, 0.8)',
    borderRadius: '50%',
    fontSize: fontSize ? fontSize + 10 : 28,
    width: buttonSize,
    height: buttonSize,
    cursor: 'pointer'
  };
  return (
    <div
      style={{
        height: value !== null ? null : (height || 56),
        border: value === 1 ? '0.5px solid ' + color : value === 0 ? '0.5px solid ' + color : border,
        borderRadius,
        // boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.05)',
        width: '100%',
        paddingLeft: 12,
        paddingRight: 12,
        marginBottom: 12,
        fontSize: fontSize || 18
      }}
    >
      <div>
        <div style={{
          lineHeight: (height || 56) + 'px',
          float: 'left'
        }}
        >
          <span style={{ fontSize: fontSize, color: 'rgba(0, 0, 0, 0.9)' }}>{label}</span>
        </div>
        <div style={{
          float: 'right',
          marginTop: (height - buttonSize) / 2
        }}
        >
          <div
            style={{
              ...buttonStyle,
              border: value === 1 ? '1px solid rgba(17, 174, 42, 0.4)' : '1px solid rgba(115, 115, 115, 0.8)'
            }}
            onClick={() => { if (value === 1) { setValue(null); } if (value !== 1) { setValue(1); } }}
          >
            <center>
              <i
                style={{
                  color: value === 1 ? 'rgba(17, 174, 42, 0.4)' : 'rgba(115, 115, 115, 0.8)',
                  position: 'relative',
                  top: height >= 56 ? 0 : -4
                }}
                className='fa fa-thumbs-up'
              />
            </center>
          </div>
          <div
            style={{
              ...buttonStyle,
              marginLeft: 5
            }}
            onClick={() => { if (value === 0) { setValue(null); } if (value !== 0) { setValue(0); } }}
          >
            <center>
              <i
                style={{
                  color: value === 0 ? 'rgba(176, 0, 0, 0.4)' : 'rgba(115, 115, 115, 0.8)',
                  position: 'relative',
                  top: height >= 56 ? 0 : -4
                }}
                className='fa fa-thumbs-down'
              />
            </center>
          </div>
        </div>
      </div>

      {
          value !== null && (
            <div style={{ clear: 'both' }}>
              {props.children}
              {props.children && <div style={{ height: 20, width: '100%' }} />}
            </div>
          )
        }
    </div>
  );
}
;

export default RatingTopFlopButton;
